export default __webpack_public_path__ + "static/media/sofiapro-light-webfont.6272bcf7.woff2";